import { Link as WaspRouterLink, routes } from 'wasp/client/router';
import { LoginForm } from 'wasp/client/auth';
import { AuthPageLayout } from './AuthPageLayout';

// Define the appearance configuration
// Using hex values for Wasp auth forms (required format)
const authAppearance = {
  colors: {
    brand: '#EC4899', // primary (semantic)
    brandAccent: '#F9A8D4', // primary-300 (semantic)
    submitButtonText: 'white',
    inputBackground: 'white',
    inputBorder: '#F5D0FE', // primary-200 (semantic)
    inputBorderHover: '#F9A8D4', // primary-300 (semantic)
    inputBorderFocus: '#EC4899', // primary (semantic)
    dividerBackground: '#F5D0FE', // primary-200 (semantic)
  },
  borderRadii: {
    inputBorderRadius: '6px',
    buttonBorderRadius: '6px',
  },
};

export default function Login() {
  return (
    <AuthPageLayout>
      <LoginForm
        appearance={authAppearance}
        // Optionally add your logo here
        // logo="/your-logo.png"
        socialLayout="vertical"
      />
      <br />
      <span className="text-sm font-medium text-neutral-900 dark:text-neutral-200">
        Don't have an account yet?{' '}
        <WaspRouterLink
          to={routes.SignupRoute.to}
          className="underline text-primary-700 hover:text-primary dark:text-primary dark:hover:text-primary-400"
        >
          Go to signup
        </WaspRouterLink>
        .
      </span>
      <br />
      <span className="text-sm font-medium text-neutral-900 dark:text-neutral-200">
        Forgot your password?{' '}
        <WaspRouterLink
          to={routes.RequestPasswordResetRoute.to}
          className="underline text-primary-700 hover:text-primary dark:text-primary dark:hover:text-primary-400"
        >
          Reset it
        </WaspRouterLink>
        .
      </span>
    </AuthPageLayout>
  );
}
